module.exports = __webpack_public_path__ + "static/contact-form-2-7e7c88fefb34789aa88c4532fbc32339.jpg";